var _path, _path2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNewLogoBlack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 81,
    viewBox: "0 0 79 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.4387 13.5408L30.3445 67.5838C27.8612 75.0006 20.9152 80 13.0937 80C5.39295 80 0.438078 71.7063 3.62734 64.6971C16.0925 37.3015 26.1769 1 1.62125e-05 1H39.4124C45.9148 1 50.5031 7.37483 48.4387 13.5408Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4124 1V1C31.5172 1 24.5104 6.05908 22.0261 13.5533L4.11993 67.5714C2.09162 73.6902 6.64744 80 13.0937 80V80M39.4124 1V1C45.9148 1 50.5031 7.37483 48.4387 13.5408L30.3445 67.5838C27.8612 75.0006 20.9152 80 13.0937 80V80M39.4124 1H1.61678e-05C26.1769 1 16.0925 37.3015 3.62734 64.6971C0.438078 71.7063 5.39295 80 13.0937 80V80",
    stroke: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M53.2939 9.5856L71.2132 63.6431C73.8826 71.6959 67.8868 80 59.4031 80C54.0537 80 49.3031 76.5807 47.6047 71.5082L29.5237 17.5046C26.8068 9.38973 32.8453 1 41.4029 1C46.8027 1 51.5949 4.46006 53.2939 9.5856Z",
    fill: "url(#paint0_linear_1_3)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_3",
    x1: 62.6219,
    y1: 80.0879,
    x2: 36.189,
    y2: 1.05284,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.7
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewLogoBlack);
export default __webpack_public_path__ + "static/media/new_logo_black.2e1137fa4fa601a81f1d97d7419dd612.svg";
export { ForwardRef as ReactComponent };